import { AxiosError } from 'axios';
import { GET_GROUP_RESIT_REGISTRATION_REVIEW } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { GET_GROUP_RESIT_REGISTRATION_REVIEW_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import { CandidateModel, CandidateSubject } from './model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface GroupResitRegistrationResponse extends CandidateModel {
  subject: CandidateSubject;
  examYear: string;
  gstNo: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: GroupResitRegistrationResponse[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetGroupResitReview = ({ uuid, onSuccess, onError }: Input) => {
  const getGroupResitReview = async () => {
    const res = await axiosClient.get<GroupResitRegistrationResponse[]>(
      GET_GROUP_RESIT_REGISTRATION_REVIEW(uuid)
    );
    return res.data;
  };

  return useCustomQuery(GET_GROUP_RESIT_REGISTRATION_REVIEW_KEY, getGroupResitReview, {
    onSuccess,
    onError,
  });
};
